import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/Layout'
import BaseRouter from '@/components/BaseRouter'
import { basePort } from 'portfinder'
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: resolve => require(['@/views/redirect/index'], resolve)
      }
    ]
  },
  {
    name: 'login',
    path: '/login',
    component: resolve => require(['@/views/login/login'], resolve),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: resolve => require(['@/views/login/AuthreDirect'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: resolve => require(['@/views/error-page/404'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: resolve => require(['@/views/error-page/401'], resolve),
    hidden: true
  },
  {
    path: '/questionPage',
    component: resolve => require(['@/views/questionPage/index'], resolve),
    hidden: true
  },
  {
    path: '/questionPagePaging',
    component: resolve => require(['@/views/questionPage/paging'], resolve),
    hidden: true
  },
  {
    path: '/questionPageDetail',
    component: resolve => require(['@/views/questionPage/detail'], resolve),
    hidden: true
  },
  {
    path: '/letter',
    component: resolve => require(['@/views/letter/index'], resolve),
    hidden: true
  },
  {
    path: '/pdf-preview',
    component: resolve => require(['@/components/PdfPreview'], resolve),
    name: 'PdfPreview',
    hidden: true
  },
  {
    path: '/credit',
    component: resolve => require(['@/views/auth/credit'], resolve),
    name: 'credit',
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [
      {
        path: 'dashboard',
        component: resolve => require(['@/views/dashboard/index'], resolve),
        name: 'dashboard',
        meta: {
          title: '首页',
          icon: 'dashboard',
          noCache: true
        }
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/auth',
    component: Layout,
    alwaysShow: true,
    meta: { title: '权限管理', icon: 'auth-ico', actionName: 'g_auth_mgr' },
    redirect: '/auth/staffList',
    children: [
      {
        path: 'staff-list',
        component: resolve => require(['@/views/auth/staffList'], resolve),
        name: 'staffList',
        meta: { title: '员工管理', actionName: 'g_staff_list' }
      },
      {
        path: 'set-staff-role',
        component: resolve => require(['@/views/auth/setStaffRole'], resolve),
        hidden: true,
        name: 'setStaffRole',
        meta: { title: '配置权限' },
        actionName: 'g_staff_list'
      },
      {
        path: 'role-list',
        component: resolve => require(['@/views/auth/roleList'], resolve),
        name: 'roleList',
        meta: { title: '角色管理', actionName: 'g_role_list' }
      },
      {
        path: 'role-add',
        component: resolve => require(['@/views/auth/roleAdd'], resolve),
        name: 'roleAdd',
        hidden: true,
        meta: { title: '新增角色', actionName: 'g_role_list' }
      },
      {
        path: 'auth-list',
        component: resolve => require(['@/views/auth/authList'], resolve),
        name: 'authList',
        meta: { title: '权限管理', actionName: 'g_auth_list' }
      },
      {
        hidden: true,
        path: 'teacher-add',
        component: resolve => require(['@/views/auth/teacherAdd'], resolve),
        name: 'teacherAdd',
        meta: { title: '添加员工账号', actionName: 'g_staff_add' }
      },
      {
        path: 'authenticationManage',
        component: resolve => require(['@/views/auth/authenticationManageList'], resolve),
        name: 'authenticationManage',
        meta: { title: '认证管理', actionName: 'g_authentication_manag' }
      }
    ]
  },

  {
    path: '/customer-manage',
    component: Layout,
    meta: { title: '客户管理', icon: 'course-ico', actionName: 'g_customer_manage' },
    alwaysShow: true,
    children: [
      {
        path: 'intentionAgent',
        component: resolve => require(['@/views/customer-manage/intentionAgent'], resolve),
        name: 'intentionAgent',
        meta: { title: '意向代理商', actionName: 'g_intention_agent' }
      },
      {
        path: 'customerList',
        component: resolve => require(['@/views/customer-manage/customerList'], resolve),
        name: 'customerList',
        meta: { title: '正式代理商', actionName: 'g_customer_manage' }
      },
      {
        path: 'assessmentList',
        component: resolve => require(['@/views/customer-manage/assessmentList'], resolve),
        name: 'assessmentList',
        meta: { title: '合同考核情况', actionName: 'g_assessment_manage' }
      },
      {
        hidden: true,
        path: 'customerDetail',
        component: resolve => require(['@/views/customer-manage/customerDetail'], resolve),
        name: 'customerDetail',
        meta: { title: '代理商详情', actionName: 'g_customer_manage' }
      },
      {
        hidden: true,
        path: 'studyFeedback',
        component: resolve => require(['@/views/customer-manage/studyFeedback'], resolve),
        name: 'studyFeedback',
        meta: { title: '学习反馈', actionName: 'g_customer_manage' }
      },
      {
        path: 'customerEdit',
        component: resolve => require(['@/views/customer-manage/customerEdit'], resolve),
        name: 'customerEdit',
        hidden: true,
        meta: { title: '代理商编辑', actionName: 'g_customer_manage' }
      },
      {
        path: 'FreeAccountList',
        component: resolve => require(['@/views/customer-manage/FreeAccountList'], resolve),
        name: 'FreeAccountList',
        meta: { title: '免费账号管理', actionName: 'g_free_account_manage' }
      },
      {
        path: 'map',
        component: resolve => require(['@/views/recharge-manage/map'], resolve),
        name: 'map',
        hidden: true,
        meta: { title: '高德地图', icon: 'recharge-ico' }
      },
      {
        path: 'storeLocation',
        component: resolve => require(['@/views/customer-manage/storeLocation'], resolve),
        name: 'storeLocation',
        meta: { title: '门店位置检查', actionName: 'g_customer_location' }
      },
      {
        hidden: true,
        path: 'examRecordDetail',
        component: resolve => require(['@/views/customer-manage/examRecordDetail'], resolve),
        name: 'examRecordDetail',
        meta: { title: '考试记录详情', actionName: 'g_customer_manage' }
      },
      {
        hidden: true,
        path: 'homeworkRecordDetail',
        component: resolve => require(['@/views/customer-manage/homeworkRecordDetail'], resolve),
        name: 'homeworkRecordDetail',
        meta: { title: '门店启动核心问题梳理表', actionName: 'g_customer_manage' }
      }
    ]
  },
  {
    path: '/agentManage',
    component: Layout,
    name: 'mechanismManage',
    meta: { title: '门店管理', icon: 'recharge-ico', actionName: 'g_agent_mgr' },
    alwaysShow: true,
    children: [
      {
        path: 'agentList',
        component: resolve => require(['@/views/recharge-manage/agentList'], resolve),
        name: 'agentList',
        meta: { title: '门店列表', actionName: 'g_agent_list' }
      },
      {
        path: 'whiteList',
        component: resolve => require(['@/views/agentManage/whiteList/index'], resolve),
        name: 'whiteList',
        meta: { title: '门店白名单', actionName: 'g_agent_whitelist_index' }
      }, //g_agent_whitelist
      {
        path: 'addSchool',
        component: resolve => require(['@/views/recharge-manage/addSchool'], resolve),
        name: 'addSchool',
        hidden: true,
        meta: { title: '门店管理-新增门店', actionName: 'g_agent_add' }
      },
      {
        path: 'addSchoolReplenish',
        component: resolve => require(['@/views/recharge-manage/addSchoolReplenish'], resolve),
        name: 'addSchoolReplenish',
        hidden: true,
        meta: { title: '门店-其他信息设置', actionName: 'g_agent_add' }
      },
      {
        path: 'editSchool',
        component: resolve => require(['@/views/recharge-manage/addSchool'], resolve),
        hidden: true,
        name: 'editSchool',
        meta: { title: '门店管理-编辑门店', actionName: 'g_agent_update' }
      },

      {
        path: 'setSchoolMeal',
        component: resolve => require(['@/views/recharge-manage/setSchoolMeal'], resolve),
        hidden: true,
        name: 'setSchoolMeal',
        meta: { title: '门店管理-设置套餐', actionName: 'g_agent_setting_product' }
      },
      {
        path: 'setMemberMeal',
        component: resolve => require(['@/views/recharge-manage/setMemberMeal'], resolve),
        hidden: true,
        name: 'setMemberMeal',
        meta: { title: '门店管理-设置会员卡', actionName: 'g_agent_setting_product' }
      },
      {
        path: 'setEquity',
        component: resolve => require(['@/views/recharge-manage/setEquity'], resolve),
        hidden: true,
        name: 'setEquity',
        meta: { title: '门店管理-设置权益卡', actionName: 'g_agent_setting_product' }
      },
      {
        path: 'setServiceMeal',
        component: resolve => require(['@/views/recharge-manage/setServiceMeal'], resolve),
        hidden: true,
        name: 'setServiceMeal',
        meta: { title: '门店管理-设置会员卡', actionName: 'g_agent_setting_product' }
      },
      {
        path: 'videoProductList',
        component: resolve => require(['@/views/recharge-manage/videoProductList'], resolve),
        hidden: true,
        name: 'videoProductList',
        meta: { title: '影音时长设置', actionName: 'g_agent_setting_product' }
      },
      {
        path: 'commenSchool',
        component: resolve => require(['@/views/recharge-manage/commenSchool/commenSchool'], resolve),
        name: 'commenSchool',
        meta: { title: '公立校列表', actionName: 'g_commenSchool_list' }
      }
    ]
  },
  {
    path: '/ptManage',
    component: Layout,
    meta: { title: '模板管理', icon: 'course-ico', actionName: 'g_product_template_manage' },
    alwaysShow: true,
    children: [
      {
        path: 'productTemplateList',
        component: resolve => require(['@/views/product-template-manage/productTemplateList'], resolve),
        name: 'productTemplateList',
        meta: { title: '会员卡模板', actionName: 'g_product_template_list' }
      }
    ]
  },
  {
    path: '/courseManage',
    component: Layout,
    meta: { title: '课程管理', icon: 'course-ico', actionName: 'g_course_mgr' },
    children: [
      {
        path: 'courseList',
        component: resolve => require(['@/views/course-manage/CourseList'], resolve),
        name: 'courseList',
        meta: { title: '课程管理', actionName: 'g_course_list' }
      },
      {
        path: 'courseKnowledgePoints',
        component: resolve => require(['@/views/course-manage/CourseKnowledgePoints'], resolve),
        name: 'courseKnowledgePoints',
        meta: { title: '课程知识点设置', actionName: 'g_course_list_knowledge' }
      },
      {
        path: 'addCourse',
        component: resolve => require(['@/views/course-manage/AddCourse'], resolve),
        name: 'addCourse',
        hidden: true,
        meta: { title: '课程管理-编辑课程', actionName: 'g_course_add' }
      },
      {
        path: 'addCourseChapter',
        component: resolve => require(['@/views/course-manage/AddCourseChapter'], resolve),
        name: 'addCourseChapter',
        hidden: true,
        meta: { title: '课程管理-编辑课次', actionName: 'g_course_add' }
      },
      {
        path: 'addCourseFile',
        component: resolve => require(['@/views/course-manage/AddCourseFile'], resolve),
        name: 'addCourseFile',
        hidden: true,
        meta: { title: '上传讲义', actionName: 'g_course_add' }
      },
      {
        path: 'courseCatalog',
        component: resolve => require(['@/views/course-manage/CourseCatalog'], resolve),
        name: 'courseCatalog',
        hidden: true,
        meta: { title: '课程管理-课程大纲', actionName: 'g_course_catalog' }
      },
      {
        path: 'videoList',
        component: resolve => require(['@/views/video-manage/VideoList'], resolve),
        name: 'videoList',

        meta: { title: '视频切片管理', actionName: 'g_course_video_slices_list' }
      },

      {
        path: 'chapterList',
        component: resolve => require(['@/views/course-manage/ChapterList'], resolve),
        name: 'chapterList',
        meta: { title: '课次列表', actionName: 'g_course_chapter_list' }
      },
      {
        path: 'chapterReviser',
        component: resolve => require(['@/views/course-manage/ChapterReviser'], resolve),
        name: 'chapterReviser',
        hidden: true,
        meta: { title: '课次审校', actionName: 'g_course_video_slices_update' }
      },
      {
        path: 'videoEdit',
        component: resolve => require(['@/views/video-manage/videoPoint'], resolve),
        name: 'videoEdit',
        hidden: true,
        meta: { title: '视频编辑', actionName: 'g_course_video_slices_update' }
      },
      {
        path: 'courseTypeList',
        component: resolve => require(['@/views/course-manage/CourseTypeList'], resolve),
        name: 'courseTypeList',
        meta: { title: '班型解读管理', actionName: 'g_course_type_list' }
      },
      {
        path: 'studyPlanTemplateList',
        component: resolve => require(['@/views/course-manage/studyPlan/studyPlanTemplate'], resolve),
        name: 'studyPlanTemplateList',
        meta: { title: '学习规划模板管理', actionName: 'g_study_plan_template' }
      },
      {
        path: 'studyPlantemplateDetail',
        component: resolve => require(['@/views/course-manage/studyPlan/studyPlantemplateDetail'], resolve),
        name: 'studyPlantemplateDetail',
        hidden: true,
        meta: { title: '创建学习规划模版', actionName: 'g_study_plan_template' }
      },
      {
        path: 'questionList',
        component: resolve => require(['@/views/course-manage/questionList'], resolve),
        name: 'questionList',
        meta: { title: '试题列表', actionName: 'g_question_list' }
      },
      {
        path: 'exerciseList',
        component: resolve => require(['@/views/course-manage/exerciseList'], resolve),
        name: 'exerciseList',
        hidden: true,
        meta: { title: '测练电子版', actionName: 'g_exercise_list' }
      },
      {
        path: 'chapterRecitationPointsList',
        component: resolve =>
          require(['@/views/course-manage/chapterRecitationPoints/ChapterRecitationPointsList.vue'], resolve),
        name: 'chapterRecitationPointsList',
        meta: { title: '背记资料管理', actionName: 'g_recitation_points_mgr' }
      },
      {
        path: 'chapterRecitationPoints',
        component: resolve =>
          require(['@/views/course-manage/chapterRecitationPoints/ChapterRecitationPoints'], resolve),
        name: 'chapterRecitationPoints',
        hidden: true,
        meta: { title: '背记资料', actionName: 'g_recitation_points_mgr' }
      },
      {
        path: 'chapterRecitationPointsDetail',
        component: resolve =>
          require(['@/views/course-manage/chapterRecitationPoints/ChapterRecitationPointsDetail'], resolve),
        name: 'chapterRecitationPointsDetail',
        hidden: true,
        meta: { title: '背记资料详情', actionName: 'g_recitation_points_mgr' }
      },
      {
        path: 'chapterRecitationPointsSet',
        component: resolve =>
          require(['@/views/course-manage/chapterRecitationPoints/ChapterRecitationPointsSet'], resolve),
        name: 'chapterRecitationPointsSet',
        hidden: true,
        meta: { title: '设置背记资料', actionName: 'g_course_add' }
      },
      {
        path: 'wholeMemoryManage',
        component: resolve => require(['@/views/course-manage/wholeMemoryManage/index'], resolve),
        name: 'wholeMemoryManage',
        meta: { title: '整篇背诵管理', actionName: 'g_memory_text' }
      },
      {
        path: 'proofReading',
        component: resolve => require(['@/views/course-manage/wholeMemoryManage/proofReading'], resolve),
        name: 'proofReading',
        hidden: true,
        meta: { title: '背诵资料审校', actionName: 'g_memory_text' }
      },
      {
        path: 'textMemoryAdd',
        component: resolve => require(['@/views/course-manage/wholeMemoryManage/add'], resolve),
        name: 'textMemoryAdd',
        hidden: true,
        meta: { title: '背诵资料', actionName: 'g_memory_text' }
      },
      {
        path: 'textbookAdd',
        component: resolve => require(['@/views/course-manage/wholeMemoryManage/addbook'], resolve),
        name: 'textbookAdd',
        hidden: true,
        meta: { title: '教材资料', actionName: 'g_memory_text' }
      },
      {
        path: 'systemprobemList',
        component: resolve => require(['@/views/course-manage/systemprobemList'], resolve),
        name: 'problemList',
        meta: { title: '问题反馈', actionName: 'g_systemprobem_list' }
      },
      {
        path: 'systemprobemDetail',
        component: resolve => require(['@/views/course-manage/systemprobemDetail'], resolve),
        hidden: true,
        name: 'problemDetail',
        meta: { title: '问题反馈详情', actionName: 'g_systemprobem_list' }
      },
      {
        path: 'questionEdit',
        component: resolve => require(['@/views/course-manage/questionEdit'], resolve),
        name: 'questionEdit',
        hidden: true,
        meta: { title: '添加试题', actionName: 'g_question_list' }
      },
      {
        path: 'questionDetail',
        component: resolve => require(['@/views/course-manage/questionDetail'], resolve),
        name: 'questionDetail',
        hidden: true,
        meta: { title: '试题详情', actionName: 'g_question_list' }
      },
      {
        path: '',
        component: resolve => require(['@/views/course-manage/paper-group/index'], resolve),
        name: 'paperGroup',
        redirect: '/library/math/search',
        hidden: true,
        meta: { title: '选题组卷', actionName: '' },
        children: [
          {
            path: 'library/:subject/search',
            component: resolve => require(['@/views/course-manage/paper-group/libraryList'], resolve),
            name: 'libraryList',
            hidden: true,
            meta: { title: '选题组卷', actionName: 'g_question_list' }
          }
        ]
      },
      {
        path: 'paperAnalysis',
        component: resolve => require(['@/views/course-manage/paper-group/paperAnalysis'], resolve),
        name: 'paperAnalysis',
        hidden: true,
        meta: { title: '试题详情', actionName: 'g_question_list' }
      },
      {
        path: 'paperList',
        component: resolve => require(['@/views/course-manage/paper-group/paperList'], resolve),
        name: 'paperList',
        hidden: true,
        meta: { title: '组卷详情', actionName: '' }
      }
    ]
  },
  // {
  //   path: '/videoManage',
  //   component: Layout,
  //   meta: { title: '视频管理', icon: 'video-ico', actionName: 'g_course_video_slices' },
  //   children: [
  //     {
  //       path: 'videoList',
  //       component: resolve => require(['@/views/video-manage/VideoList'], resolve),
  //       name: 'videoList',
  //       meta: { title: '课程视频', actionName: 'g_course_video_slices_list' }
  //     },
  //     {
  //       path: 'videoEdit',
  //       component: resolve => require(['@/views/video-manage/videoEdit'], resolve),
  //       name: 'videoEdit',
  //       hidden: true,
  //       meta: { title: '视频编辑', actionName: 'g_course_video_slices_update' }
  //     }
  //   ]
  // },
  // {
  //   path: '/main',
  //   component: Layout,
  //   meta: { title: '内容分类', icon: 'content-ico', actionName: 'g_product_category' },
  //   children: [
  //     {
  //       path: 'index',
  //       component: resolve => require(['@/views/main/index'], resolve),
  //       name: 'index',
  //       meta: { title: '内容分类', actionName: 'g_product_category_list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/meal',
  //   component: Layout,
  //   meta: { title: '套餐模板管理', icon: 'template-ico', actionName: 'g_product_template' },
  //   redirect: '/meal/mealList',
  //   children: [
  //     {
  //       path: 'mealList',
  //       component: resolve => require(['@/views/meal/index'], resolve),
  //       name: 'mealList',
  //       meta: { title: '套餐模板管理', actionName: 'g_product_template_list' }
  //     },
  //     {
  //       path: 'addMealTemplate',
  //       component: resolve => require(['@/views/meal/mealTemplate'], resolve),
  //       name: 'addMealTemplate',
  //       meta: { title: '新增套餐模板', actionName: 'g_product_template_add' },
  //       hidden: true
  //     },
  //     {
  //       path: 'editMealTemplate',
  //       component: resolve => require(['@/views/meal/mealTemplate'], resolve),
  //       name: 'editMealTemplate',
  //       meta: { title: '编辑套餐模板', actionName: 'g_product_template_update' },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: '/finance',
  //   component: Layout,
  //   alwaysShow: true,
  //   meta: { title: '财务管理', icon: 'finance-ico', actionName: 'g_income_confirm' },
  //   redirect: '/finance/index',
  //   children: [
  //     {
  //       path: 'order-list',
  //       component: resolve => require(['@/views/finance/orderList'], resolve),
  //       name: 'orderList',
  //       meta: { title: '订单列表', actionName: 'g_order_list' }
  //     },
  //     {
  //       path: 'index',
  //       component: resolve => require(['@/views/finance/index'], resolve),
  //       name: 'finance',
  //       meta: { title: '现金对账', actionName: 'g_income_confirm_list' }
  //     },
  //     {
  //       path: 'refund',
  //       component: resolve => require(['@/views/finance/refund'], resolve),
  //       name: 'refund',
  //       meta: { title: '退费管理', actionName: 'g_refund_order_list' }
  //     },
  //     {
  //       path: 'refund-detail',
  //       component: resolve => require(['@/views/finance/refundDetail'], resolve),
  //       name: 'refundDetail',
  //       hidden: true,
  //       meta: { title: '退费详情', actionName: 'g_refund_order_list' }
  //     },
  //     {
  //       path: 'order-detail',
  //       component: resolve => require(['@/views/finance/orderDetail'], resolve),
  //       name: 'orderDetail',
  //       hidden: true,
  //       meta: { title: '订单详情', actionName: 'g_refund_order_list' }
  //     }
  //   ]
  // },
  {
    path: '/statistics',
    alwaysShow: true,
    component: Layout,
    redirect: '/statistics/signupData',
    meta: { title: '数据统计', icon: 'statistics', actionName: 'sf_statistics' },
    children: [
      // {
      //   path: 'signupData',
      //   component: resolve => require(['@/views/statistics/signupData'], resolve),
      //   name: 'SignupData',
      //   meta: { title: '报名统计', actionName: 'sf_signupData' }
      // },
      // {
      //   path: 'enrollSourceData',
      //   component: resolve => require(['@/views/statistics/enrollSourceData'], resolve),
      //   name: 'enrollSourceData',
      //   meta: { title: '招生渠道统计', actionName: 'sf_enrollSourceData' }
      // },
      // {
      //   path: 'classAwayData',
      //   component: resolve => require(['@/views/statistics/classAwayData'], resolve),
      //   name: 'ClassAwayData',
      //   meta: { title: '课消统计', actionName: 'sf_classAwayData' }
      // },
      {
        path: 'registeredData',
        component: resolve => require(['@/views/statistics/registeredData'], resolve),
        name: 'registeredData',
        meta: { title: '在读会员统计', actionName: 'sf_registeredData' }
      },
      {
        path: 'registeredHistory',
        component: resolve => require(['@/views/statistics/registeredHistory'], resolve),
        name: 'registeredHistory',
        hidden: true,
        meta: { title: '在读趋势', actionName: 'sf_registeredHistory' }
      },
      {
        path: 'renew',
        component: resolve => require(['@/views/statistics/renew'], resolve),
        name: 'renew',
        hidden: true,
        meta: { title: '续费详情', actionName: 'sf_renew' }
      },
      {
        path: 'refund',
        component: resolve => require(['@/views/statistics/refund'], resolve),
        name: 'refund',
        hidden: true,
        meta: { title: '退费详情', actionName: 'sf_renew' }
      },
      {
        path: 'studyTimeData',
        component: resolve => require(['@/views/statistics/studyTimeData'], resolve),
        name: 'studyTimeData',
        meta: { title: '学习时长统计', actionName: 'sf_studyTimeData' }
      },
      {
        path: 'serviceData',
        component: resolve => require(['@/views/statistics/serviceData'], resolve),
        name: 'serviceData',
        meta: { title: '服务数据统计', actionName: 'sf_serviceData' }
      },
      {
        path: 'studentStudyTimeDetail',
        component: resolve => require(['@/views/statistics/studentStudyTimeDetail'], resolve),
        name: 'studentStudyTimeDetail',
        hidden: true,
        meta: { title: '学习时长明细', actionName: 'sf_studentStudyTimeDetail' }
      },
      {
        path: 'classAwayDetail',
        component: resolve => require(['@/views/statistics/classAwayDetail'], resolve),
        name: 'ClassAwayDetail',
        hidden: true,
        meta: { title: '明细详情', actionName: 'sf_classAwayDetail' }
      },
      {
        path: 'resignRateData',
        component: resolve => require(['@/views/statistics/resignRateData'], resolve),
        name: 'resignRateData',
        meta: { title: '伴学师离职率统计', actionName: 'sf_resignRateData'}
      },
      {
        path: 'resignDetail',
        component: resolve => require(['@/views/statistics/resignDetail'], resolve),
        name: 'resignDetail',
        hidden: true,
        meta: { title: '离职伴学师明细', actionName: 'sf_resignRateData'}
      },

      {
        path: 'expConversion',
        component: resolve => require(['@/views/statistics/expConversion'], resolve),
        name: 'expConversion',
        meta: { title: '体验转化统计', actionName: 'sf_expConversion' }
      },
      {
        path: 'scoreImprovementRate',
        component: resolve => require(['@/views/statistics/scoreImprovementRate'], resolve),
        name: 'scoreImprovementRate',
        meta: { title: '提分率统计', actionName: 'sf_scoreImprovementRate'}
      },
      // {
      //   path: 'resignRateData',
      //   component: resolve => require(['@/views/statistics/resignRateData'], resolve),
      //   name: 'resignRateData',
      //   meta: { title: '伴学师离职率统计' }
      // },
      // {
      //   path: 'resignDetail',
      //   component: resolve => require(['@/views/statistics/resignDetail'], resolve),
      //   name: 'resignDetail',
      //   hidden: true,
      //   meta: { title: '离职伴学师明细' }
      // },
      {
        path: 'scoreImprovementDetail',
        component: resolve => require(['@/views/statistics/scoreImprovementDetail'], resolve),
        name: 'scoreImprovementDetail',
        hidden: true,
        meta: { title: '提分明细', actionName: 'sf_scoreImprovementRate'}
      },
      {
        path: 'readingData',
        component: resolve => require(['@/views/statistics/readingData'], resolve),
        name: 'readingData',
        meta: { title: '精准读统计', actionName: 'sf_readingData' }
      },
      {
        path: 'reWordData',
        component: resolve => require(['@/views/statistics/reWordData'], resolve),
        name: 'reWordData',
        meta: { title: '拾光记单词统计', actionName: 'sf_reWordData' }
      }
    ]
  },
  {
    path: '/goods',
    component: Layout,
    alwaysShow: true,
    meta: { title: '商品管理', icon: 'sgmall', actionName: 'g_goods' },
    redirect: '/goods/goodsList',
    children: [
      {
        path: 'goodsList',
        component: resolve => require(['@/views/goods/index'], resolve),
        name: 'GoodsList',
        meta: { title: '商品列表', actionName: 'g_goods_list' }
      },
      {
        path: 'goodsDetail',
        component: resolve => require(['@/views/goods/goodsDetail'], resolve),
        name: 'GoodsDetail',
        hidden: true,
        meta: { title: '商品详情', actionName: 'g_goods_detail' }
      },
      {
        path: 'priceSetting',
        component: resolve => require(['@/views/goods/priceSetting'], resolve),
        name: 'PriceSetting',
        hidden: true,
        meta: { title: '提货价格设置', actionName: '' }
      },
      {
        path: 'goodsOrderList',
        component: resolve => require(['@/views/goods/goodsOrderList'], resolve),
        name: 'GoodsOrderList',
        meta: { title: '订单列表', actionName: 'g_goods_order_list' }
      },
      {
        path: 'goodsOrderDetail',
        component: resolve => require(['@/views/goods/goodsOrderDetail'], resolve),
        name: 'GoodsOrderDetail',
        hidden: true,
        meta: {
          title: '订单详情',
          actionName: 'g_goods_order_detail',
          actionNameArray: ['g_goods_order_list_factory'],
          noCache: true
        }
      },

      {
        path: 'releaseRecords',
        component: resolve => require(['@/views/goods/releaseRecords'], resolve),
        name: 'ReleaseRecords',
        meta: {
          title: '发货记录',
          actionName: 'g_goods_release_records'
        }
      },
      {
        path: 'serviceList',
        component: resolve => require(['@/views/goods/serviceList'], resolve),
        name: 'ServiceList',
        meta: { title: '售后列表', actionName: 'g_goods_service_list' }
      },
      {
        path: 'serviceDetail',
        component: resolve => require(['@/views/goods/serviceDetail'], resolve),
        name: 'ServiceDetail',
        hidden: true,
        meta: {
          title: '售后详情',
          actionName: 'g_goods_service_detail',
          actionNameArray: ['g_goods_order_list_factory']
        }
      },
      {
        path: 'goodsOrderListFactory',
        component: resolve => require(['@/views/goods/goodsOrderListFactory'], resolve),
        name: 'GoodsOrderListFactory',
        meta: { title: '工厂订单列表', actionNameArray: ['g_goods_order_list_factory'] }
      },
      {
        path: 'serviceListFactory',
        component: resolve => require(['@/views/goods/serviceListFactory'], resolve),
        name: 'ServiceListFactory',
        meta: { title: '工厂售后列表', actionNameArray: ['g_goods_service_list_factory'] }
      }
    ]
  },
  {
    path: '/finance-sgsf',
    component: Layout,
    alwaysShow: true,
    meta: { title: '门店财务管理', icon: 'finance-ico', actionName: 'g_store_income_confirm' },
    redirect: '/finance-sgsf/index',
    children: [
      {
        path: 'order-list',
        component: resolve => require(['@/views/finance-sgsf/orderList'], resolve),
        name: 'orderListSgsf',
        meta: { title: '订单列表', actionName: 'g_store_order_list' }
      },
      {
        path: 'index',
        component: resolve => require(['@/views/finance-sgsf/index'], resolve),
        name: 'financeSgsf',
        meta: { title: '现金对账', actionName: 'g_store_income_confirm_list' }
      },
      {
        path: 'refund',
        component: resolve => require(['@/views/finance-sgsf/refund'], resolve),
        name: 'refundSgsf',
        meta: { title: '退费管理', actionName: 'g_store_refund_order_list' }
      },
      {
        path: 'refund-detail',
        component: resolve => require(['@/views/finance-sgsf/refundDetail'], resolve),
        name: 'refundDetailSgsf',
        hidden: true,
        meta: { title: '退费详情', actionName: 'g_store_refund_order_detail' }
      },
      {
        path: 'order-detail',
        component: resolve => require(['@/views/finance-sgsf/orderDetail'], resolve),
        name: 'orderDetailSgsf',
        hidden: true,
        meta: { title: '订单详情', actionName: 'g_store_refund_order_list' }
      },
      {
        path: 'order-pay-list',
        component: resolve => require(['@/views/finance-sgsf/orderPayList'], resolve),
        name: 'orderPayListSgsf',
        meta: { title: '支付订单列表', actionName: 'g_store_order_pay_list' }
      },
      {
        path: 'sale-list',
        component: resolve => require(['@/views/finance-sgsf/saleList'], resolve),
        name: 'saleListSgsf',
        meta: { title: '产品销售明细', actionName: 'g_store_sale_list' }
      },
      {
        path: 'accountList',
        component: resolve => require(['@/views/finance-sgsf/accountList'], resolve),
        name: 'AccountList',
        meta: { title: '各代理商账户', actionName: 'g_store_account_list' }
      },
      {
        path: 'accountTransaction',
        component: resolve => require(['@/views/finance-sgsf/accountTransaction'], resolve),
        name: 'AccountTransaction',
        meta: { title: '门店流水明细', actionName: 'g_store_account_transaction' }
      },
      {
        path: 'agentDailyBalanceDetail',
        component: resolve => require(['@/views/finance-sgsf/agentDailyBalanceDetail'], resolve),
        name: 'AgentDailyBalanceDetail',
        hidden: true,
        meta: { title: '每日代理商余额明细' }
      }
    ]
  },
  {
    path: '/operate',
    component: Layout,
    alwaysShow: true,
    meta: { title: '运营管理', icon: 'operate-ico', actionName: 'g_operation_mgr' },
    redirect: '/operate/index',
    children: [
      {
        path: 'index',
        component: resolve => require(['@/views/operate/index'], resolve),
        name: 'operate',
        meta: { title: '学习日报配置', actionName: 'g_study_daily_list' }
      },
      {
        path: 'barrage',
        component: resolve => require(['@/views/operate/barrage/index'], resolve),
        name: 'barrage',
        meta: { title: '弹幕管理', actionName: 'g_barrage_mgr' }
      },
      {
        path: 'dailyreport',
        component: resolve => require(['@/views/operate/workplan/dailyReport'], resolve),
        name: 'dailyreport',
        meta: { title: '工作日报管理', actionName: 'g_daily_report_mgr' }
      },
      {
        path: 'teacherData',
        component: resolve => require(['@/views/operate/teacherData/index'], resolve),
        name: 'teacherData',
        meta: { title: '伴学师数据', actionName: 'g_teacher_data' }
      },
      {
        path: 'message-notification',
        component: resolve => require(['@/views/operate/messageNotification/index'], resolve),
        name: 'messageNotification',
        meta: { title: '消息通知', actionName: 'g_message_mgr' }
      },
      {
        path: 'message-statistics',
        component: () => import('@/views/operate/messageStatistics/index'),
        name: 'messageStatistics',
        hidden: true,
        meta: { title: '消息统计', actionName: 'g_message_statistics' }
      },
      {
        path: 'add-message',
        component: resolve => require(['@/views/operate/messageNotification/addMessage'], resolve),
        name: 'addMessage',
        hidden: true,
        meta: { title: '消息通知', actionName: 'g_message_mgr' }
      },
      {
        path: 'morningMap',
        component: resolve => require(['@/views/operate/morningMap/index'], resolve),
        name: 'morningMap',
        meta: { title: '每日早安图', actionName: 'g_morning_mgr' }
      },
      {
        path: 'addMorningMap',
        component: resolve => require(['@/views/operate/morningMap/addMorningMap'], resolve),
        name: 'addMorningMap',
        hidden: true,
        meta: { title: '每日早安图', actionName: 'g_morning_mgr' }
      }
    ]
  },
  {
    path: '/deviceManager',
    component: Layout,
    alwaysShow: true,
    meta: { title: '伴学本设备管理', icon: 'device-ico', actionName: 'g_device_mgr' },
    redirect: '/deviceManager/SNbindingList',
    children: [
      {
        path: 'SNbindingList',
        component: resolve => require(['@/views/deviceManager/SNbindingList'], resolve),
        name: 'SNbindingList',
        meta: { title: 'SN绑定记录', actionName: 'g_sn_binding_list' }
      },
      {
        path: 'SNbindingDetail',
        component: resolve => require(['@/views/deviceManager/SNbindingDetail'], resolve),
        name: 'SNbindingDetail',
        hidden: true,
        meta: { title: 'SN绑定详情', actionName: 'g_sn_binding_detail' }
      },
      {
        path: 'clearSN',
        component: resolve => require(['@/views/deviceManager/clearSN'], resolve),
        name: 'clearSN',
        meta: { title: 'SN清空记录', actionName: 'g_clear_sn_list' }
      },
      {
        path: 'SNList',
        component: resolve => require(['@/views/deviceManager/SNList'], resolve),
        name: 'SNList',
        meta: { title: '设备使用年限', actionName: 'g_sn_list' }
      },
      {
        path: 'deviceManage',
        component: resolve => require(['@/views/deviceManager/deviceManage'], resolve),
        name: 'deviceManage',
        meta: { title: '内部样机管理', actionName: 'g_sn_device_manage' }
      },
      {
        path: 'exceptionIndex',
        component: resolve => require(['@/views/deviceManager/exceptionIndex'], resolve),
        name: 'exceptionIndex',
        meta: { title: '设备异常情况', actionName: 'g_unit_exception' }
      },
      {
        path: 'deviceAccess',
        component: resolve => require(['@/views/deviceManager/deviceAccess'], resolve),
        name: 'deviceAccess',
        meta: { title: '设备访问情况', actionName: 'g_unit_device_access' }
      },
      {
        path: 'deviceMigrate',
        component: resolve => require(['@/views/deviceManager/deviceMigrate'], resolve),
        name: 'deviceMigrate',
        meta: { title: '设备迁移', actionName: 'g_device_migrate' }
      }
    ]
  },
  {
    path: '/web-manage',
    component: Layout,
    meta: { title: '官网管理', icon: 'course-ico', actionName: 'g_web_manage' },
    alwaysShow: true,
    children: [
      {
        path: 'activity',
        component: resolve => require(['@/views/web-manage/activity'], resolve),
        name: 'activity',
        meta: { title: '文章列表', actionName: 'g_web_manage' }
      },
      {
        path: 'activityAdd',
        component: resolve => require(['@/views/web-manage/activity/activityAdd'], resolve),
        name: 'ActivityAdd',
        hidden: true,
        meta: { title: '创建活动', actionName: 'g_web_manage' }
      },
      {
        path: 'teacherList',
        component: resolve => require(['@/views/web-manage/teacherList/teacherList.vue'], resolve),
        name: 'teacherList',
        meta: { title: '主讲老师管理', actionName: 'g_teacher_manage' }
      },
      {
        path: 'addTeacher',
        component: resolve => require(['@/views/web-manage/teacherList/addTeacher.vue'], resolve),
        name: 'addTeacher',
        hidden: true,
        meta: { title: '主讲老师管理', actionName: 'g_teacher_manage' }
      }
    ]
  },
  {
    path: '/staffSpace/suggestion',
    component: resolve => require(['@/views/staffSpace/suggestion'], resolve),
    name: 'suggestion',
    hidden: true,
    meta: { title: '员工建议', icon: 'edit', actionName: 'sf_staff_space' }
  },
  {
    path: '/staffSpace/manage',
    component: resolve => require(['@/views/staffSpace/manage'], resolve),
    name: 'suggestionManage',
    hidden: true,
    meta: { title: '建议管理', icon: 'setting', actionName: 'sf_staff_space_manage' }
  }

  // {
  //   path: '/statistics',
  //   alwaysShow: true,
  //   component: Layout,
  //   redirect: '/statistics/signupData',
  //   meta: { title: '数据统计', icon: 'statistics', actionName: 'g_data_sta_report_mgr' },
  //   children: [
  //     {
  //       path: 'signupData',
  //       component: resolve => require(['@/views/statistics/signupData'], resolve),
  //       name: 'SignupData',
  //       meta: { title: '报名统计', actionName: 'g_register_sta_report' }
  //     },
  //     {
  //       path: 'enrollSourceData',
  //       component: resolve => require(['@/views/statistics/enrollSourceData'], resolve),
  //       name: 'enrollSourceData',
  //       meta: { title: '招生渠道统计', actionName: 'g_enrollSource_sta_report' }
  //     },
  //     {
  //       path: 'classAwayData',
  //       component: resolve => require(['@/views/statistics/classAwayData'], resolve),
  //       name: 'ClassAwayData',
  //       meta: { title: '课消统计', actionName: 'g_consume_sta_report' }
  //     },
  //     {
  //       path: 'classAwayDetail',
  //       component: resolve => require(['@/views/statistics/classAwayDetail'], resolve),
  //       name: 'ClassAwayDetail',
  //       hidden: true,
  //       meta: { title: '明细详情', actionName: 'g_consume_sta_report' }
  //     }
  //   ]
  // },
]

export default new Router({
  // mode: 'history',
  routes: constantRoutes
})
